import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({ providedIn: 'root'})
export class SnackBarMessage {
    constructor(private snackbar: MatSnackBar) {}

    openMessage(message: string, action = 'OK', duration = 3000) {
        this.snackbar.open(message, action, {
            duration: duration
        })
    }
}